module.exports = __webpack_public_path__ + "img/骨碎补.332ee2e1.jpg";